/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AutoWithdrawalSettingsResponse { 
    walletId: string;
    currencyName: string;
    currencyTicker: string;
    chainName: string;
    autoWithdrawalAddress: string;
    autoWithdrawalAmount?: number | null;
    minWithdrawalAmount: number;
    isAutoWithdrawalEnabled: boolean;
}

